import m1 from './img/Home/main.png'
import m2 from './img/Home/el1.png'
import m3 from './img/Home/el2.png'
export const images = [
    m1,m2,m3
];